import { Link as RouterLink } from 'react-router-dom';
import { IconExternalLink } from '@rossum/ui/icons/tabler';
import {
  IconButton,
  Stack,
  SvgIcon,
  Tooltip,
  Typography,
} from '@rossum/ui/material';

const getRuleDetailPath = (queueId: number, ruleId: number) =>
  `/queues/${queueId}/settings/rules/${ruleId}/detail`;

type RuleNameColumnProps = {
  ruleId: number;
  queueId: number;
  ruleName: string;
};

export const RuleNameColumn = ({
  ruleId,
  queueId,
  ruleName,
}: RuleNameColumnProps) => {
  return (
    <Stack
      sx={{
        maxWidth: '100%',
        height: '100%',
        justifyContent: 'space-between',
        p: 1,
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
        sx={{ maxWidth: '100%', minWidth: 0 }}
      >
        <Tooltip title={ruleName}>
          <Typography
            variant="body2"
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {ruleName}
          </Typography>
        </Tooltip>
        <IconButton
          size="small"
          component={RouterLink}
          to={getRuleDetailPath(queueId, ruleId)}
          onClick={e => {
            e.stopPropagation();
          }}
        >
          <SvgIcon fontSize="small">
            <IconExternalLink />
          </SvgIcon>
        </IconButton>
      </Stack>
    </Stack>
  );
};
